import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { CreateReleaseNote } from "./@types";

const createReleaseNote = async (payload: CreateReleaseNote) => {
  const { data } = await apiInputService.post("/releaseNotes/create", payload);

  return data;
};

export const useCreateReleaseNote = (options?: any) => {
  return useMutation(createReleaseNote, {
    ...options,
  });
};
